export default {
  publishFlow: 'publish-flow-estate'
};
